/*
 * Copyright (c) 2018 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained here in is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */
import { Location } from "history";
import { isNil } from "lodash";
import * as React from "react";
import { connect } from "react-redux";
import { Redirect, Route, RouteProps, withRouter } from "react-router";

import { RootState, Me } from "../../types/RootState";

export interface AuthRouteProps extends RouteProps {
    anonymous: boolean;
    me: Me;
    location: Location;
}

class AuthRoute extends React.Component<AuthRouteProps> {

    render() {
        if (this.props.anonymous) {
            if (!isNil(this.props.me.user)) {
                return this._redirectTo("/");
            }
        } else {
            if (isNil(this.props.me.user)) {
                return this._redirectTo("/login");
            }
            if (!this.props.me.user.profileCompleted) {
                return this._redirectTo("/edit-profile");
            }
        }

        return this._skip();
    }

    /* Implementation. */

    private _redirectTo(pathname: string) {
        if (this.props.location.pathname === pathname) {
            return this._skip();
        }
        const { component, render, anonymous, auth, location, ...rest } = this.props as any;
        return <Route exact={true}  {...rest} render={() => <Redirect to={pathname} />} />;
    }

    private _skip() {
        const { anonymous, auth, location, ...rest } = this.props as any;
        return <Route exact={true}  {...rest} />;
    }
}

export type AuthRouteConnectedProps = RouteProps & {
    anonymous: boolean;
};

export const AuthRouteConnected = withRouter(connect(
    (state: RootState, ownProps: AuthRouteConnectedProps) => ({
        ...ownProps,
        me: state.me,
    }),
)(AuthRoute) as any) as React.ComponentClass<AuthRouteConnectedProps>;


// WEBPACK FOOTER //
// ./src/components/App/AuthRoute.tsx